import { Component, Input } from "@angular/core";

@Component({
    selector: 'zoom',
    templateUrl: 'zoom.component.html',
    styleUrls: ['zoom.component.scss']
})
export class ZoomComponent {

    @Input()
    public map: L.Map;
}


// WEBPACK FOOTER //
// /app/SPA/src/app/core/maps/controls/zoom.component.ts